/* globals dataLayer */

const cookiePrefix = 'cwcc_'

export const setTrackingCookie = (name, value) => {
  // Set or delete tracking cookies depending on the given value
  const expires = value ? 'Tue, 19 Jan 2038 03:14:07 UTC' : 'Thu, 01 Jan 1970 00:00:01 GMT'
  const domain = document.location.hostname
  const path = '/'
  const convertedValue = value ? 'true' : 'false'
  // Only store cookies if the given value is 'true' or the cookie existed before
  const cookieValueIsStorable = convertedValue === 'true' || typeof (getCookieValue(name)) !== 'undefined'
  if (cookieValueIsStorable) {
    document.cookie = `${cookiePrefix}${name}=${convertedValue};expires=${expires};domain=${domain};path=${path}`
  }
}

export const getCookieValue = (name) => {
  // regex from https://stackoverflow.com/a/21125098
  const cookie = document.cookie.match(new RegExp(`(^| )${cookiePrefix}${name}=([^;]+)`))
  if (cookie) {
    return cookie[2]
  }
}

const createCheckboxMarkup = cookieDefinition => {
  // Create the html checkbox representation for a specific cookie type
  let checked = false
  const valueFromCookie = getCookieValue(cookieDefinition.name)
  if (typeof (valueFromCookie) !== 'undefined') {
    checked = valueFromCookie
  } else {
    checked = cookieDefinition.checked
  }
  checked = checked ? 'checked="checked"' : ''

  const disabled = cookieDefinition.disabled ? 'disabled="disabled"' : ''
  const id = `cwcc-checkbox-${cookieDefinition.name}`
  return `
    <li>
      <input type="checkbox" ${checked} ${disabled} id="${id}">
      <label id="cwcc-label-${cookieDefinition.name}" for="${id}">${cookieDefinition.label}</label>
    </li>
  `
}

export const createCompleteCheckboxMarkup = cookieList => {
  // Create the complete checkbox html
  const htmlListItems = cookieList.map(cookieDefinition => createCheckboxMarkup(cookieDefinition))
  return `
    <ul>
      ${htmlListItems.join('')}
    </ul>
  `
}

export const parseEntrypoint = entrypoint => {
  if (entrypoint.startsWith('#')) {
    return document.getElementById(entrypoint.split('#')[1])
  }
  return document.body
}

const parseUserChoices = cookieList => {
  // Parse the user choices but also respect the default values that are preconfigured
  const choices = cookieList.map(cookieDefinition => {
    return {
      name: cookieDefinition.name,
      checked: cookieDefinition.disabled ? cookieDefinition.checked : document.getElementById(`cwcc-checkbox-${cookieDefinition.name}`).checked
    }
  })
  return choices
}

const switchVisibility = (elToHide, elToShow, hiddenClassName) => {
  elToHide.classList.add(hiddenClassName)
  elToShow.classList.remove(hiddenClassName)
}

const hideBanner = (hiddenClassName) => {
  document.getElementById('cwcc').classList.add(hiddenClassName)
  if (typeof dataLayer !== 'undefined' && typeof dataLayer.push === 'function') {
    dataLayer.push({
      event: 'cookieLayerUpdated',
      eventCategory: 'cookieLayer',
      eventAction: 'activateCookies',
      eventLabel: 'analyticsCookies'
    })
  }
}

export const showSettings = () => {
  const mainText = document.getElementById('cwcc-main-text')
  const settingsArea = document.getElementById('cwcc-settings-area')
  const hiddenClassName = 'd-none'
  const settingsButton = document.getElementById('cwcc-settings-button')

  document.getElementById('cwcc').classList.remove(hiddenClassName)

  switchVisibility(mainText, settingsArea, hiddenClassName)
  settingsButton.classList.add(hiddenClassName)
}

export const addEventListeners = (hiddenClassName, cookieList) => {
  // # Buttons and links
  const closeSettings = document.getElementById('cwcc-close-settings')
  const openSettings = document.getElementById('cwcc-open-settings')
  const settingsButton = document.getElementById('cwcc-settings-button')
  const refuseAll = document.getElementById('cwcc-refuse-all')
  const acceptAll = document.getElementById('cwcc-accept-all')
  const save = document.getElementById('cwcc-save')
  // # Text areas
  const mainText = document.getElementById('cwcc-main-text')
  const settingsArea = document.getElementById('cwcc-settings-area')
  // # Event listeners
  // ## Visibility switching
  if (closeSettings) {
    closeSettings.addEventListener('click', () => {
      switchVisibility(settingsArea, mainText, hiddenClassName)
    })
  }
  if (openSettings) {
    openSettings.addEventListener('click', () => {
      switchVisibility(mainText, settingsArea, hiddenClassName)
      settingsButton.classList.add(hiddenClassName)
    })
  }
  if (settingsButton) {
    settingsButton.addEventListener('click', () => {
      switchVisibility(mainText, settingsArea, hiddenClassName)
      settingsButton.classList.add(hiddenClassName)
    })
  }
  // ## Cookie related buttons
  if (refuseAll) {
    refuseAll.addEventListener('click', () => {
      // Set all cookies to false / delete them unless they are disabled by default, then use the preconfigured value
      cookieList.forEach(preset => {
        setTrackingCookie(preset.name, preset.disabled ? preset.checked : false)
      })
      setTrackingCookie('dismissed', true)
      hideBanner(hiddenClassName)
    })
  }
  acceptAll.addEventListener('click', () => {
    // Set all cookies to true unless they are disabled by default, then use the preconfigured value
    cookieList.forEach(preset => {
      setTrackingCookie(preset.name, preset.disabled ? preset.checked : true)
    })
    setTrackingCookie('dismissed', true)
    hideBanner(hiddenClassName)
  })
  save.addEventListener('click', () => {
    // Set the cookies according to the user choices but also respect the default settings (this is done inside parseUserChoices)
    const userChoices = parseUserChoices(cookieList)
    userChoices.forEach(choice => {
      setTrackingCookie(choice.name, choice.checked)
    })
    setTrackingCookie('dismissed', true)
    hideBanner(hiddenClassName)
  })
  // Set default cookies.
  if (!getCookieValue('dismissed')) {
    const userChoices = parseUserChoices(cookieList)
    userChoices.forEach(choice => {
      setTrackingCookie(choice.name, choice.checked)
    })
  }
}
